import Box from '@components/ui/layout/Box';
import { Text } from '@components/ui/typography';
import { parse } from '@config/theme';
import React, { PropsWithChildren } from 'react';
export const BlogTags = ({
  children
}: PropsWithChildren) => {
  return <Box display="flex" flexWrap="wrap" mb={{
    _: '4',
    md: '24'
  }}>
      {children}
    </Box>;
};
export const BlogTag = ({
  children
}: PropsWithChildren) => {
  return <Text variant="micro" color="shade500" className={tag}>
      {children}
    </Text>;
};
const tag = parse({
  px: '3',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  alignItems: 'center',
  mr: '2',
  mb: '2'
}, "t5d2bxb");

require("./Tags.linaria.module.css!=!../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./Tags.tsx");